const map = {
	"./br.svg": 931,
	"./de.svg": 610,
	"./ee.svg": 569,
	"./es.svg": 87,
	"./fr.svg": 647,
	"./maxhuddleston.jpg": 59,
	"./mx.svg": 612,
	"./ru.svg": 564
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;